import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class TagApi {
  static getAllTagCollections(page, pageSize, filters, sorted) {
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.tagCollectionList, { params });
  }

  static getSingleCollection({ id }) {
    return axios.get(ApiEndpoints.tagCollection.replace(':id', id));
  }

  static getCollections(params) {
    // let params = drfQueryParams(page, pageSize, filters, sorted, filter_contains);
    return axios.get(ApiEndpoints.tagCollectionList, { params: { theme: params.theme_id } });
  }

  static saveTagCollection(params, id = null) {
    if (id) {
      return axios.put(ApiEndpoints.tagCollection.replace(':id', id), params);
    }
    return axios.post(ApiEndpoints.tagCollectionList, params);
  }

  static deleteCollection({ id }) {
    return axios.delete(ApiEndpoints.tagCollection.replace(':id', id));
  }

  // / Tag Values
  static saveTagValue(params, id = null) {
    if (id) {
      return axios.put(ApiEndpoints.tagValueDetail.replace(':id', id), params);
    }
    return axios.post(ApiEndpoints.tagValue, params);
  }

  static getTagValues(params) {
    return axios.get(ApiEndpoints.tagValue, { params });
  }

  // / Object Tags
  static getObjectTags(params = {}, shallowFetch = false) {
    const endPoint = shallowFetch ? ApiEndpoints.tagObjectListShallow : ApiEndpoints.tagObjectList;
    const queryParams = drfQueryParams(
      params.page,
      params.pageSize,
      params.filters,
      params.sorted,
      params.filter_contains
    );
    return axios.get(endPoint, { params: queryParams });
  }

  static deleteObjectTag({ id }) {
    return axios.delete(ApiEndpoints.tagObject.replace(':id', id));
  }

  static saveObjectTag(params, id = null) {
    if (id) {
      return axios.put(ApiEndpoints.tagObject.replace(':id', id), params);
    }
    return axios.post(ApiEndpoints.tagObjectList, params);
  }

  // ------ Tag Theme API ------
  static getTagThemes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.tagThemeList, { params });
  }

  // ------ Tag Collection API ------
  static getAllTags(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.tagCollectionList, { params });
  }

  static getTag({ id }) {
    const url = ApiEndpoints.tagCollection.replace(':id:', id);
    return axios.get(url);
  }

  static createTag(params) {
    return axios.post(ApiEndpoints.tagCollectionList, params);
  }

  static updateTag(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.tagCollection.replace(':id:', id), data);
  }

  static deleteTag({ id }) {
    return axios.delete(ApiEndpoints.tagCollection.replace(':id:', id));
  }

  // ------ Tag Collection Value API ------
  static getAllTagValues(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.tagValue, { params });
  }

  static getTagValue({ id }) {
    return axios.get(ApiEndpoints.tagValueDetail.replace(':id:', id));
  }

  static createTagValue(params) {
    return axios.post(ApiEndpoints.tagValue, params);
  }

  static updateTagValue(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.tagValueDetail.replace(':id:', id), data);
  }

  static deleteTagValue({ id }) {
    return axios.delete(ApiEndpoints.tagValueDetail.replace(':id:', id));
  }

  static getCombinedTagCollectionValues(props) {
    const {
      page, pageSize, filters, sorted
    } = props;

    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.tagValue, { params });
  }

  // ------ Tagged Item/Object API ------
  static getAllItemTags(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.tagObjectList, { params });
  }

  static getItemTag({ id }) {
    return axios.get(ApiEndpoints.tagObject.replace(':id:', id));
  }

  static createItemTag(params) {
    return axios.post(ApiEndpoints.tagObjectList, params);
  }

  static updateItemTag(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.tagObject.replace(':id:', id), data);
  }

  static deleteItemTag({ id }) {
    return axios.delete(ApiEndpoints.tagObject.replace(':id:', id));
  }

  static bulkCreateItemTags({ tags, versionId }) {
    const params = { bulk: tags };
    const versionSuffix = versionId ? `?version_id=${versionId}` : '';
    return axios.post(ApiEndpoints.tagObjectBulk + versionSuffix, params);
  }

  static bulkUpdateItemTags({ tags, versionId }) {
    const params = { bulk: tags };
    const versionSuffix = versionId ? `?version_id=${versionId}` : '';
    return axios.put(ApiEndpoints.tagObjectBulk + versionSuffix, params);
  }

  static bulkDeleteItemTags({ tags, versionId }) {
    const params = { data: { bulk: tags } };
    const versionSuffix = versionId ? `?version_id=${versionId}` : '';
    return axios.delete(ApiEndpoints.tagObjectBulkDelete + versionSuffix, params);
  }

  static addTagToUsers(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.tagValueAddUsers.replace(':id:', id), params);
  }

  static removeTagFromUsers(data) {
    const { id, params } = data;
    return axios.post(ApiEndpoints.tagValueRemoveUsers.replace(':id:', id), params);
  }

  static getTagValuesForCollection({ collectionId }) {
    const params = {
      collection: collectionId,
      page_size: 500,
      ordering: 'name'
    };
    return axios.get(ApiEndpoints.tagValue, { params });
  }
}

export default TagApi;
